import { Check, Star } from "lucide-react";
import { pricing } from "@/data/content";

export const Pricing = () => {
  return (
    <section id="hinnasto" className="py-16 sm:py-24 bg-[#FDFBF7]">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-base font-bold text-[#245037] uppercase tracking-wide">
            Hinnasto
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#1C1917]">
            Selkeät hinnat, ei yllätyksiä
          </h2>
          <p className="mt-4 text-lg sm:text-xl leading-relaxed text-[#44403C]">
            Et sitoudu pitkiin sopimuksiin. Maksat vain käyttämästäsi ajasta.
            <span className="block mt-2 text-base text-[#78716C]">
              * Hinnat ovat suuntaa-antavia esimerkkejä.
            </span>
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6 sm:gap-8 items-stretch">
          {pricing.map((p, i) => (
            <div
              key={i}
              data-testid={`pricing-card-${i}`}
              className={`rounded-2xl p-8 border flex flex-col ${
                p.featured
                  ? "bg-[#245037] text-white border-[#245037] shadow-lg md:scale-105"
                  : "bg-white text-[#1C1917] border-[#E8E2D5] shadow-sm"
              }`}
            >
              {p.featured && (
                <span className="inline-flex items-center gap-1 self-start bg-[#E8C88A] text-[#245037] text-sm font-bold px-3 py-1 rounded-full mb-4">
                  <Star className="w-4 h-4 fill-[#245037]" /> Suosituin
                </span>
              )}
              <h3 className={`text-2xl font-bold ${p.featured ? "text-white" : "text-[#1C1917]"}`}>
                {p.name}
              </h3>
              <div className="mt-4 flex items-end gap-2">
                <span className="text-4xl font-extrabold">{p.price}</span>
                <span className={`text-lg pb-1 ${p.featured ? "text-[#E8E2D5]" : "text-[#78716C]"}`}>
                  {p.unit}
                </span>
              </div>
              <p className={`mt-3 text-base ${p.featured ? "text-[#E8E2D5]" : "text-[#44403C]"}`}>
                {p.note}
              </p>
              <ul className="mt-6 space-y-3 flex-1">
                {p.items.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-base">
                    <Check
                      strokeWidth={3}
                      className={`w-5 h-5 mt-0.5 shrink-0 ${p.featured ? "text-[#E8C88A]" : "text-[#245037]"}`}
                    />
                    {item}
                  </li>
                ))}
              </ul>
              <a
                href="#yhteys"
                data-testid={`pricing-cta-${i}`}
                className={`mt-8 text-center rounded-xl px-6 py-4 text-lg font-bold transition-transform active:scale-95 ${
                  p.featured
                    ? "bg-[#E8C88A] text-[#245037] hover:bg-[#dab873]"
                    : "bg-[#245037] text-white hover:bg-[#1A3B28]"
                }`}
              >
                Varaa aika
              </a>
            </div>
          ))}
        </div>

        <p className="mt-8 text-center text-lg font-semibold text-[#245037]">
          💡 Kotikäynnit oikeuttavat usein kotitalousvähennykseen.
        </p>
      </div>
    </section>
  );
};
